import type { EmptyObject } from '@change-corgi/core/types';

import { SectionSeparator } from 'src/app/pages/petitionDetails/shared/components';

import { useIsFullSunriseEnabled } from '../../hooks/isFullSunriseEnabled';
import { SECTION_ID_MAPPING, useScrollToSection } from '../../hooks/useScrollToSection';
import { useSupporterVoicesSection } from '../supportersVoices/hooks/useSupporterVoicesSection';

import { SignaturesDistributionContainerSunrise } from './components/SignaturesDistributionContainerSunrise';
import { SupporterVoices } from './components/supportersVoices';
import { SupporterVoices as SupporterVoicesSunrise } from './components/SupporterVoicesSunrise';
import { TheSupportersTitle } from './components/TheSupportersTitle';
import { TheSupportersContextProvider, useTheSupportersContext } from './shared/context';

const TheSupportersInner: React.FC<EmptyObject> = () => {
	const {
		data: { isSunriseSupporterVoicesEnabled },
	} = useIsFullSunriseEnabled();

	const {
		data: { showSupporterVoicesSection },
	} = useSupporterVoicesSection();

	const {
		data: { hasMap },
	} = useTheSupportersContext();

	const {
		data: { refs },
	} = useScrollToSection();

	return (
		<div id={SECTION_ID_MAPPING.SUPPORTER_VOICES} ref={refs[SECTION_ID_MAPPING.SUPPORTER_VOICES]}>
			<SectionSeparator />
			<div className="mb-6 lg:mb-16">
				{showSupporterVoicesSection ? (
					<>
						<TheSupportersTitle />
						{isSunriseSupporterVoicesEnabled ? <SupporterVoicesSunrise /> : <SupporterVoices />}
					</>
				) : null}
				{hasMap ? <SignaturesDistributionContainerSunrise /> : null}
			</div>
		</div>
	);
};

export const TheSupportersSunrise: React.FC<EmptyObject> = () => {
	return (
		<TheSupportersContextProvider>
			<TheSupportersInner />
		</TheSupportersContextProvider>
	);
};
